import { Dialog } from 'vant';
// import icon from '@/asserts/common/icon/qs-appupdata-icon.png';

const icon = '';

const appDownloadUrl = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.black.unique';

const version = {
/**
     *  比较版本大小
     *
     * @param {*} v1 版本1
     * @param {*} v2
     * @returns
     */
  versionCompare(v1, v2) {
    // 去掉收尾空格
    v1 = v1.replace(/(^\s+)|(\s+$)/gi, '');
    v2 = v2.replace(/(^\s+)|(\s+$)/gi, '');

    // 空检查
    if (!v1 || !v2) {
      return false;
    }
    // 截取v1,v2中的版本数字
    v1 = /\d(\.|\d)*\d/gi.exec(v1)[0];
    v2 = /\d(\.|\d)*\d/gi.exec(v2)[0];
    // 版本比较，我们分为三个数组然后比较
    let arr1 = v1.split('.');
    arr1 = arr1.map(item => parseInt(item, 10));
    let arr2 = v2.split('.');
    arr2 = arr2.map(item => parseInt(item, 10));
    if (arr1[0] > arr2[0]) {
      return true;
    }
    if (arr1[0] === arr2[0]) {
      if (arr1[1] > arr2[1]) {
        return true;
      } if (arr1[1] === arr2[1]) {
        if (arr1[2] >= arr2[2]) {
          return true;
        }
        return false;
      }
    }
    return false;
  },

  /**
     *
     * 展示app升级提示弹窗  需要传入this;
     *
     */
  showAppUpDate(vm, option) {
    const { ckey, message, confirmButtonText } = option || {};
    const defaultCKey = 'CK1439223791341';
    const defaultMessage = '该优惠为最新版骑士特权APP用户专享，请更新至最新版';
    // 埋点
    // let obj_type = '';
    // if (vm.$route && vm.$route.name === 'tbDetail') {
    //     obj_type = 'mall_detail_tbk_but_popup';
    // }
    const html = `
      <div style="position:relative;height: 250px;">
          <div style="position:absolute;width:188px;margin: 0 auto;left: 0;right: 0;top: -101px;">
              <img width="100%" src="${icon}">
          </div>
          <h2 style="padding-top:75px;font-size:17px;color:#333333;font-weight:bold">APP更新提示</h2>
          <p style="padding-top:25px;font-size:16px;color:#333333">${message || defaultMessage}</p>
      </div>
      `;
    Dialog.confirm({
      title: '',
      message: message || html,
      confirmButtonText: confirmButtonText || '立即下载',
    })
      .then(() => {
        // on confirm
        window.location.href = `${appDownloadUrl}&ckey=${ckey || defaultCKey}`;
      })
      .catch(() => {
        // on cancel
      });
  },
};
export default version;
